import './DriftIndicator.css'

export interface DriftIndicatorProps {
	status: boolean
}

export const DriftIndicator = ({ status }: DriftIndicatorProps) => {

	return (
		<div className='drift-indicator-wrapper'>
			<div className={`drift-indicator ${status ? 'active' : ''}`}>
				<div className='drift-indicator-inner-wrapper'>
					<div className='drift-indicator-icon-wrapper'>
						<img src='./icons/16px/drift.png' alt='drift' />
					</div>
					<div className='drift-indicator-text-wrapper'>
						<p>ДРИФТ</p>
					</div>
				</div>
			</div>
		</div>

	)

}